"use strict";

import { onReady } from './ready.js';
import { addAttributesToOuterLinks, backToTop, anchorScroll } from './common.js';
import { initObservers } from './observers.js';
import { initCardSwipers } from '../blocks/cards.js';
import { initFeaturesCarousel } from '../blocks/features-carousel.js';
import { initSectorsCarousel } from '../blocks/sectors-carousel.js';
import { initArticlesCarousel } from '../blocks/articles-carousel.js';
import { initLogosCarousel } from '../blocks/logos-carousel.js';
import { initMarqueeText } from '../blocks/marqueetext.js';
import { initContactForms } from '../blocks/contact-form.js';
import { initBannerParallax } from '../blocks/banner.js';
import { ShareButtons } from './globals.js';
import { initLenis } from './lenis.js';
import { initHomeHeroParticles } from '../partials/home-hero-particles.js';

function applyPageBackgroundColor() {
    const meta = document.querySelector('meta[name="page-background-color"]');
    const color = meta?.getAttribute('content')?.trim();
    if (color) {
        document.body.style.backgroundColor = color;
    } else {
        document.body.style.removeProperty('background-color');
    }
}

function initCore() {
    initLenis();
    addAttributesToOuterLinks();
    backToTop();
    anchorScroll();
    applyPageBackgroundColor();
    initObservers();
    initCardSwipers();
	initFeaturesCarousel();
	initSectorsCarousel();
	initArticlesCarousel();
    initLogosCarousel();
    initMarqueeText();
    initContactForms();
    initBannerParallax();
    initHomeHeroParticles();
    ShareButtons?.update?.();
}

onReady(initCore);
